import HttpClient from "utils/HttpClient/HttpClient"
import {
    SUCCESSFUL_ACCOUNT_PAYMENT,
    SUCCESSFUL_CC_URL_PAYMENT,
    SUCCESSFUL_CONFIRM_PAYMENT_CREDIT_CARD,
    SUCCESSFUL_TIGO_MONEY_PAYMENT,
    SUCCESSFUL_MARK_SALEORDER_IN_PROGRESS
} from "./actionConst";

import { UPDATE_ONLINE_PAYMENT_ID } from "reducers/quotastopay/actionConst";
import { SHOW_ERROR_MESSAGE, SHOW_SUCCESS_MESSAGE } from 'reducers/application/actionConst';
import { UPDATE_SHOW_LOADING } from 'reducers/application/actionConst';

export const makeAccountPayment = (paymentData, resolve, reject) => dispatch => {
    dispatch({
        type: UPDATE_SHOW_LOADING,
        payload: true
    });
    new HttpClient(true).post("b2c/pay/account", paymentData)
        .then((response) => {
            console.log("Successful Payment Account");
            dispatch({
                type: SUCCESSFUL_ACCOUNT_PAYMENT,
                payload: response.data
            });
            dispatch({
                type: UPDATE_SHOW_LOADING,
                payload: false
            });
            resolve("Successful");
        })
        .catch((error) => {
            console.log("Failed Payment Account");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
            dispatch({
                type: UPDATE_SHOW_LOADING,
                payload: false
            });
            reject("Failed");
        })
}

export const getCCUrlPayment = (paymentData, resolve, reject) => dispatch => {

    dispatch({
        type: UPDATE_SHOW_LOADING,
        payload: true
    });

    new HttpClient(true).post("b2c/pay/creditcard", paymentData)
        .then((response) => {
            console.log("Successful getCCUrlPayment");
            dispatch({
                type: SUCCESSFUL_CC_URL_PAYMENT,
                payload: response.data
            });

            dispatch({
                type: UPDATE_ONLINE_PAYMENT_ID,
                payload: response.data.onlinePaymentId
            });

            dispatch({
                type: UPDATE_SHOW_LOADING,
                payload: false
            });

            resolve("Successful");
        })
        .catch((error) => {
            console.log("Failed Payment Account");
            dispatch({
                type: UPDATE_SHOW_LOADING,
                payload: false
            });

            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });

            reject("Failed");
        })
}


export const makeConfirmCreditCardPayment = (onlinePaymentId) => dispatch => {
    new HttpClient(true).post("b2c/pay/creditcard/confirm?onlinePaymentId=" + onlinePaymentId)
        .then((response) => {
            console.log("Successful Payment Confirm Credit Card");
            dispatch({
                type: SUCCESSFUL_CONFIRM_PAYMENT_CREDIT_CARD,
                payload: response.data
            });           
        })
        .catch((error) => {
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
        })
}

export const makeTigoMoneyPayment = (paymentData, phoneNumber, resolve, reject) => dispatch => {
    dispatch({
        type: UPDATE_SHOW_LOADING,
        payload: true
    });
    new HttpClient(true).post("b2c/pay/tigomoney?phoneNumber=" + phoneNumber, paymentData)
        .then((response) => {
            console.log("Successful Tigo Money Payment");
            dispatch({
                type: SUCCESSFUL_TIGO_MONEY_PAYMENT,
                payload: response.data
            });
            dispatch({
                type: UPDATE_SHOW_LOADING,
                payload: false
            });
            resolve("Successful");            
        })
        .catch((error) => {
            console.log("Failed Tigo Money Payment");
            dispatch({
                type: SHOW_ERROR_MESSAGE,
                payload: error.response.data.message
            });
            dispatch({
                type: UPDATE_SHOW_LOADING,
                payload: false
            });
            reject("Failed");
        })
}

export const markSaleOrderInProgress = (token) => dispatch => {
    new HttpClient(true).post("b2c/payment/creditcard/inprogress?token=" + token)
        .then((response) => {
            console.log("Successful mark saleorder in progress");            
        })
        .catch((error) => {
            
        })
}



// WEBPACK FOOTER //
// ./src/reducers/payment/paymentActions.js